<div
  *ngIf="!menu?.children || !menu.children?.length; else withChildren"
  [class.active]="menu?.active"
  class="menu_item"
  (click)="navigate(menu.route)"
>
  <i class="menu_item__icon {{ menu?.iconClass }}"> </i>
  <span [class.hidden]="!isSideMenuExpanded">{{ menu?.name | translate}}</span>
</div>

<!-- Menu with children -->
<ng-template #withChildren>
  <div
    [ngClass]="{
      active: menu?.active,
      expanded: menu?.expanded
    }"
    class="menu_item"
    (click)="toggle()"
  >
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center">
        <i class="menu_item__icon {{ menu?.iconClass }}"> </i>
        <span [class.hidden]="!isSideMenuExpanded">{{ menu?.name | translate}}</span>
      </div>
      <i class="icon-drop-arrow-down-table-default-icon"></i>
    </div>
  </div>
  <div class="childrens" [class.childrens--expanded]="menu.expanded && isSideMenuExpanded">
    <div *ngFor="let child of menu.children" [class.active]="child?.active" class="menu_item child" (click)="navigate(child.route)">
      <span [class.hidden]="!isSideMenuExpanded">{{ child?.name | translate}}</span>
    </div>
  </div>
</ng-template>
